import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from 'services/hooks';
import { locations } from 'services/routes/locations';

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const {
    authStore: { isLoggedIn },
  } = useAuthStore();

  const location = useLocation();

  if (!isLoggedIn) {
    return (
      <Navigate
        to={locations.general.register.pathname('')}
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
